module.exports = __webpack_public_path__ + "static/media/KY.865343e7.svg";